export default __webpack_public_path__ + "static/media/hht1_song_06.fdeea06f.png";